import { Component, Input, OnChanges, OnInit, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { TcemsService  } from 'src/app/api/tcems.service';
import { Phi, PhiUpdate } from 'src/app/model/phi/phi';
import { CalendarModule } from 'primeng/calendar';
import { PhoneNumber, PhoneNumberUpdate } from '../../model/phi/phone-number';
import { EmailAddress } from '../../model/phi/email-address';
import { ContactType } from '../../model/util/contact_type';
import { selectContactTypes, selectTransactionType } from '../../state/app.state';
import { select, Store } from '@ngrx/store';
import { User } from 'src/app/model/util/user';

@Component({
  selector: 'app-phi-summary',
  templateUrl: './phi-summary.component.html',
  styleUrls: ['./phi-summary.component.css']
})
export class PhiDetailsComponent implements OnInit, OnChanges{
  showOptOut: boolean = false;
  optOutOptions = [
    { label: 'Opt-In', value: true },
    { label: 'Opt-Out', value: false }
  ]

  constructor(private store: Store, private tcems: TcemsService) {
  }
  //@Input() phiId: number;
  @Input() phi: Phi;
  @Input() header: string;
  @Input() editablePhi: boolean;
  @Input() showAbbreviated = false;
  @Input() loggedInUser?: User;
  @Input() encounterId?: number = 0;
  @Input() wlpPhoneNumber?: string;
  @Output() optOutStatusChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() currentMemberChange = new EventEmitter<Phi>();

  currentMemberSubscriber: Phi;

  idx: number;
  showPhoneEditor = false;
  showEmailEditor = false;
  showAddressEditor = false;
  originalPhi: string[] = [];
  originalDob: Date;

  contactTypes$ = this.store.select(selectContactTypes);
  ContactTypes: ContactType[];

  ngOnInit(): void
  {
    this.contactTypes$.subscribe(t => {this.ContactTypes = t; });
    this.instantiatePhi();
  }

  ngOnChanges(changes: SimpleChanges): void 
  {
    this.instantiatePhi();
  }

  instantiatePhi(): void
  {
    //Can't be too sure what we got for phi... fetch from the db again
    //this.tcems.getPhi(this.phiId).toPromise().then
    //(
    //  phi =>
    //  {
    //    this.phi = Object.assign(new Phi(), phi);
    this.phi = Object.assign(new Phi(), this.phi);

        //Fetch our subscriber
        if(!this.phi.isSubscriber)
        {
          this.tcems.getPhi(this.phi.currentSubscriber.phiId).toPromise().then
          (
            sub => 
            {
              this.currentMemberSubscriber = Object.assign(new Phi(), sub);
            }
          )
        }
        else
          this.currentMemberSubscriber = this.phi;

    this.showOptOut = this.phi.emailOptedIn == null;

  }

  updatePhiName(phiToUpdate: Phi): void {
    let phiUpdate: PhiUpdate = new PhiUpdate();
    phiUpdate.firstName = phiToUpdate.firstName;
    phiUpdate.lastName = phiToUpdate.lastName;
    phiUpdate.middleInitial = phiToUpdate.middleInitial;
    phiUpdate.preferredName = phiToUpdate.preferredName;

    this.tcems.updatePhi
    (
      {
        phiId: phiToUpdate.phiId,
        phiUpdate
      }
    ).toPromise()
      .then
      (
        result => {
          phiUpdate = result;
          this.currentMemberChange.emit(phiToUpdate);
        }
      )
      .catch
    (
      e =>
      {
        console.log('Update PHI Name Failed: ' + e);
      }
    );
  }

  updateDob(phiToUpdate: Phi): void {
    let phiUpdate: PhiUpdate = new PhiUpdate();
    phiUpdate.dob = phiToUpdate.dob;

    // this.tcems.updatePhi(phiUpdate).toPromise()
    this.tcems.updatePhi
    (
      {
        phiId: phiToUpdate.phiId,
        phiUpdate
      }
    ).toPromise()
      .then
      (
        result =>
        phiUpdate = result
      )
      .catch
    (
      e =>
      {
        console.log('Update PHI DOB Failed: ' + e);
      }
    );
  }

  updatePhiOptOut(phiToUpdate: Phi): void {
    let phiUpdate: PhiUpdate = new PhiUpdate();
    phiUpdate.hasOptedOut = phiToUpdate.hasOptedOut;
    phiUpdate.emailOptedIn = phiToUpdate.emailOptedIn;
    phiUpdate.smsOptedIn = phiToUpdate.smsOptedIn;
    phiUpdate.automatedOptedIn = phiToUpdate.automatedOptedIn;
    phiUpdate.transactionalOptedIn = phiToUpdate.transactionalOptedIn;

    this.tcems.updatePhi
    (
      {
        phiId: phiToUpdate.phiId,
        phiUpdate
      }
    ).toPromise()
      .then
      (
        result =>
          phiUpdate = result
      )
      .catch
    (
      e =>
      {
        console.log('Update PHI hasOptedOut Failed: ' + e);
      }
    );
    this.optOutStatusChange.emit(phiToUpdate.hasOptedOut);
  }

  setColor( n:number ) {
    switch( n ) {
      case 1:
        return 'success';
        break;
      case 2:
        return 'warning';
        break;
      case 3:
        return 'info';
        break;
      default:
        return 'danger'
    }
  }

  hemiOutboundCall(to: string, callerId: string, encounterId: string): void {
    const url = `https://hemicallrouting-2700.twil.io/hemiOutboundCall?ext=${encodeURIComponent(this.loggedInUser.extNumber)}&from=${encodeURIComponent(this.loggedInUser.twilioContactUri)}`
      + `&to=${encodeURIComponent(to)}&callerId=${encodeURIComponent(callerId)}&encounterId=${encodeURIComponent(encounterId)}&workerName=${encodeURIComponent(this.loggedInUser.username)}`
    fetch(url, { method: 'GET', keepalive: true, cache: 'no-store' })
      .catch(() => { });
  }

  isValidPhoneNumber(phoneNumber: string): boolean {
    if (!phoneNumber) {
      return false;
    }
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    return digitsOnly.length >= 10;
  }

}
